import React from 'react';
import { Button, Nav } from 'reactstrap';

const CloseActionButton = (props) => {
  function handleClick(event) {
    event.preventDefault();
    props.onClose();
  }
  return (
    <Nav className="action-button">
      <Button
        onClick={event => handleClick(event)}
      >
        <i className="fa fa-times mr-2" />
        <span className="d-none d-md-block">Close {props.label}</span>
      </Button>
    </Nav>
  );
};

export default CloseActionButton;

